module.exports = __webpack_public_path__ + "static/media/metal_clip.df0509e0.png";